<template>
  <section
    :class="['category-menu', {'-disabled': isFetching}]"
    data-cy="category-menu"
  >
    <transition
      appear
      name="fade"
      v-for="category in categories"
      :key="category.slug"
    >
      <router-link
        :class="['link', {'-disabled': isFetching}]"
        data-cy="category-item"
        active-class="-active"
        exact-active-class="-active"
        exact
        :to="category | toLink"
        @click.native="handleAnalytics(category)"
      >
        <k-icon
          class="icon"
          :icon="category.icon"
        />
        <span class="name">{{ category.name }}</span>
      </router-link>
    </transition>
  </section>
</template>

<script>
import * as types from '@store/types'
import { mapGetters } from 'vuex'
import { KIcon } from 'kaledo-components'

export default {
  components: { KIcon },
  filters: {
    toLink: (category) => ({
      name: 'Campanhas',
      query: {
        category: category.slug
      }
    })
  },

  props: {
    categories: {
      type: Array,
      required: true
    },
    active: String
  },

  computed: mapGetters({
    isFetching: types.IS_FETCHING_CAMPAIGNS
  }),

  methods: {
    handleAnalytics (category) {
      window.dataLayer.push({
        event: 'Categorias',
        categoria_clicada: category.name
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/style/reference';

.category-menu {
  background-color: $primary-color-placeholder;
  background-color: var(--color-primary);
  display: flex;
  flex-flow: row nowrap;

  &.-disabled {
    cursor: not-allowed;
  }
  & > .link {
    @extend %category-link;
    &:hover { background-color: rgba($base-color, .2); }

    &.-disabled {
      pointer-events: none;
      user-select: none;

      &:hover {
        background-color: $primary-color-placeholder;
        background-color: var(--color-primary);}
    }
  }

  @include desktop { justify-content: center; }
}

%category-link {
  height: 76px;
  flex: 1 1 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  cursor: pointer;

  text-decoration: none;
  transition: background-color 0.3s ease;
  will-change: background-color;

  & > .icon {
    color: $secondary-color-placeholder;
    color: var(--color-secondary);
    margin-top: 15px;
    margin-bottom: 6px;
    font-size: 20px;
  }

  & > .name {
    display: flex;
    align-items: center;
    height: 20px;
    padding-left: 5px;
    padding-right: 5px;
    line-height: 10px;
    font-size: 8px;
    font-weight: 700;
    text-align: center;
    text-transform: uppercase;
    color: $white-color;
  }

  &:link,
  &:hover,
  &:active { color: inherit; }

  &.-active { background-color: rgba($base-color, .2); }

  @include desktop {
    flex-direction: row;
    height: 50px;
    padding-left: 20px;
    padding-right: 20px;
    justify-content: center;
    align-items: center;
    flex: { wrap: nowrap; basis: auto; shrink: 1; grow: 0; }

    & > .name {
      font-size: 12px;
      padding-left: 10px;
      font-weight: 500;
      line-height: 14px;
    }

    & > .icon { margin: 0; }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Category/CategoryMenu.vue